import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/i18n";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Programmes from "@/pages/Programmes";
import Immersions from "@/pages/Immersions";
import Evenements from "@/pages/Evenements";
import Ligue from "@/pages/Ligue";
import Alumni from "@/pages/Alumni";
import Boutique from "@/pages/Boutique";
import UniversityTeam from "@/pages/UniversityTeam";
import ProjectPage from "@/pages/ProjectPage";
import Offre from "@/pages/Offre";
import Infos from "@/pages/Infos";
import Candidature from "@/pages/Candidature";
import { SHERBROOKE, LEGACY } from "@/content";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/programmes" element={<Programmes />} />
              <Route path="/programmes/:slug" element={<ProjectPage category="programmes" />} />
              <Route path="/immersions" element={<Immersions />} />
              <Route path="/immersions/:slug" element={<ProjectPage category="immersions" />} />
              <Route path="/evenements" element={<Evenements />} />
              <Route path="/evenements/:slug" element={<ProjectPage category="evenements" />} />
              <Route path="/offre" element={<Offre />} />
              <Route path="/candidature" element={<Candidature />} />
              <Route path="/infos" element={<Infos />} />
              <Route path="/ligue" element={<Ligue />} />
              <Route path="/sherbrooke" element={<UniversityTeam data={SHERBROOKE} />} />
              <Route path="/legacy-3r" element={<UniversityTeam data={LEGACY} />} />
              <Route path="/alumni" element={<Alumni />} />
              <Route path="/boutique" element={<Boutique />} />
            </Routes>
          </Layout>
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-right" />
      </LanguageProvider>
    </div>
  );
}

export default App;
